export default "Aides Locales Copropriétés — Subventions Régions et Collectivités pour Rénovation | Solution Éco France";
